module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'web') ? _c('section', {
    attrs: {
      "id": "hotweb"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [(_vm.type === 'web') ? _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("行业热门优站")])]) : _vm._e(), _vm._v(" "), (_vm.type === 'mobile') ? _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("分类移动媒体")])]) : _vm._e()]), _vm._v(" "), (_vm.type === 'mobile') ? _c('div', {
    staticClass: "category"
  }, [_c('span', {
    class: {
      active: _vm.categoryType === 'app'
    },
    on: {
      "click": function($event) {
        _vm.changeMobileThead('app')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/launchPreview/category-app.png",
      "alt": "app"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "industry"
  }, _vm._l((_vm.industryList), function(val, key) {
    return _c('span', {
      class: {
        active: key === _vm.currentIndustry
      },
      on: {
        "click": function($event) {
          _vm.getIndustrySite(key, val.id, true)
        }
      }
    }, [_vm._v(_vm._s(val.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "color": "#4285f4",
      "margin-top": "20px"
    }
  }, [_vm._v("点击右下角免费试投按钮，全品类优质行业网站推广马上免费试投")]), _vm._v(" "), _c('div', {
    staticClass: "industry-list clearfix"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', {
    staticStyle: {
      "background-color": "#4285f4",
      "color": "white"
    }
  }, [_c('tr', _vm._l((_vm.siteList.thead), function(item) {
    return _c('th', [_vm._v(_vm._s(item))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.siteList.tbody), function(item, index) {
    return _c('tr', {
      staticClass: "hvr-pulse-shrink"
    }, [_c('td', [_c('a', {
      attrs: {
        "href": item.previewUrl,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.logo,
        "alt": "",
        "title": "点击预览广告"
      }
    })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.type === 'web') ? _c('td', [_vm._v(_vm._s(item.domain))]) : _c('td', [_vm._v(_vm._s(item.appos))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.pv))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ip))]), _vm._v(" "), _c('td', {
      staticClass: "showtype"
    }, _vm._l((item.showtype), function(i) {
      return _c('span', [_vm._v(_vm._s(i))])
    })), _vm._v(" "), _c('td', [(_vm.type === 'web') ? _c('button', {
      staticClass: "btn-ghost",
      on: {
        "click": function($event) {
          _vm.openModal({
            head: '网盟试投设置',
            previewUrl: item.previewUrl
          })
        }
      }
    }, [_vm._v("免费试投")]) : _vm._e()])])
  }))]), _vm._v(" "), _c('pagination', {
    staticClass: "pull-right",
    attrs: {
      "initPage": _vm.page,
      "total-page": _vm.totalPage
    },
    on: {
      "go-page": _vm.goPage,
      "alert-tip": _vm.openModal
    }
  })], 1)]), _vm._v(" "), _c('modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalShow),
      expression: "modalShow"
    }],
    attrs: {
      "head": _vm.modalHead,
      "modalType": _vm.modalType,
      "subText": _vm.modalSubText,
      "preUrl": _vm.wapPreview,
      "cancelText": _vm.modalCancelText
    },
    on: {
      "colse-modal": _vm.closeModal,
      "sub-event": _vm.launchAd,
      "init-props": _vm.initProps
    }
  }, [(_vm.modalType === 'alertTip') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.modalContent)
    },
    slot: "custom"
  }) : _c('launch-temp', {
    ref: "launchTemp",
    attrs: {
      "industry-list": _vm.industryList
    },
    slot: "launchTemp"
  })], 1), _vm._v(" "), _c('tips')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b1ebdf26!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medianav/launchPreview/launchPreview.vue
// module id = 450
// module chunks = 2